var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	52950: () => (loadStrictSingletonVersion("default", "@angular/core", false, [1,19,2,0], () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	17796: () => (loadStrictSingletonVersion("default", "@angular/common", false, [1,19,2,0], () => (__webpack_require__.e(7935).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	32778: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e(8219).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	44866: () => (loadStrictSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	53358: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [1,19,2,0], () => (__webpack_require__.e(8070).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	57576: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [1,19,2,0], () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))),
	1014: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [1,19,2,0], () => (__webpack_require__.e(4456).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	1420: () => (loadStrictSingletonVersion("default", "@angular/cdk/platform", false, [1,19,2,19], () => (__webpack_require__.e(80).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))))),
	11288: () => (loadStrictSingletonVersion("default", "@angular/cdk/keycodes", false, [1,19,2,19], () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))))),
	18298: () => (loadStrictSingletonVersion("default", "@angular/cdk/private", false, [1,19,2,19], () => (__webpack_require__.e(1608).then(() => (() => (__webpack_require__(/*! @angular/cdk/private */ 9227))))))),
	29890: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers/private", false, [1,19,2,19], () => (__webpack_require__.e(996).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 98615))))))),
	30734: () => (loadStrictSingletonVersion("default", "@angular/cdk/scrolling", false, [1,19,2,19], () => (__webpack_require__.e(2356).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))))),
	32124: () => (loadStrictSingletonVersion("default", "@angular/cdk/layout", false, [1,19,2,19], () => (__webpack_require__.e(5531).then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))))),
	50568: () => (loadStrictSingletonVersion("default", "@angular/cdk/portal", false, [1,19,2,19], () => (__webpack_require__.e(9168).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))))),
	53140: () => (loadStrictSingletonVersion("default", "@angular/cdk/a11y", false, [1,19,2,19], () => (__webpack_require__.e(9721).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))))),
	56428: () => (loadSingleton("default", "@angular/cdk/overlay", false, () => (__webpack_require__.e(9189).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))))),
	64788: () => (loadStrictSingletonVersion("default", "@angular/cdk/bidi", false, [1,19,2,19], () => (__webpack_require__.e(1299).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))))),
	74924: () => (loadStrictSingletonVersion("default", "@angular/cdk/coercion", false, [1,19,2,19], () => (__webpack_require__.e(433).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))))),
	1474: () => (loadStrictSingletonVersion("default", "@angular/cdk/collections", false, [1,19,2,19], () => (__webpack_require__.e(370).then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 37989))))))),
	78764: () => (loadStrictSingletonVersion("default", "@angular/cdk/accordion", false, [1,19,2,19], () => (__webpack_require__.e(6799).then(() => (() => (__webpack_require__(/*! @angular/cdk/accordion */ 9180))))))),
	5130: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers", false, [1,19,2,19], () => (__webpack_require__.e(1920).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 39539))))))),
	40992: () => (loadStrictVersion("default", "@angular/common/http", false, [1,"auto"], () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	81307: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [1,19,2,0], () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	76144: () => (loadSingleton("default", "@angular/cdk/text-field", false, () => (__webpack_require__.e(7559).then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 69940))))))),
	95399: () => (loadStrictSingletonVersion("default", "@angular/animations/browser", false, [1,19,2,14], () => (__webpack_require__.e(655).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))))),
	37376: () => (loadStrictSingletonVersion("default", "@azure/msal-browser", false, [1,4,15,0], () => (__webpack_require__.e(1721).then(() => (() => (__webpack_require__(/*! @azure/msal-browser */ 74102))))))),
	47584: () => (loadStrictSingletonVersion("default", "@angular/router", false, [1,19,2,0], () => (__webpack_require__.e(2691).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	20878: () => (loadStrictSingletonVersion("default", "@ng-idle/core", false, [1,16,0,0], () => (__webpack_require__.e(9872).then(() => (() => (__webpack_require__(/*! @ng-idle/core */ 87491))))))),
	64496: () => (loadStrictSingletonVersion("default", "chart.js", false, [1,4,5,0], () => (__webpack_require__.e(6792).then(() => (() => (__webpack_require__(/*! chart.js */ 36792)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"80": [
		17796
	],
	"294": [
		1014,
		1420,
		11288,
		17796,
		18298,
		29890,
		30734,
		32778,
		44866,
		50568,
		52950,
		53140,
		56428,
		64788,
		74924
	],
	"316": [
		44866,
		52950
	],
	"370": [
		44866
	],
	"436": [
		17796,
		40992,
		52950
	],
	"640": [
		1420,
		11288,
		17796,
		30734,
		32778,
		44866,
		50568,
		52950,
		53140,
		56428,
		64788,
		74924
	],
	"1034": [
		1420,
		11288,
		17796,
		18298,
		30734,
		32778,
		44866,
		50568,
		52950,
		53140,
		56428,
		64788,
		74924
	],
	"1151": [
		20878,
		40992,
		52950
	],
	"1299": [
		17796
	],
	"1459": [
		17796,
		32778,
		40992,
		44866,
		52950,
		53140,
		64788,
		81307
	],
	"1570": [
		17796,
		32778,
		44866,
		52950
	],
	"1977": [
		1014,
		1420,
		11288,
		17796,
		18298,
		29890,
		30734,
		32778,
		44866,
		50568,
		52950,
		53140,
		56428,
		64788,
		74924
	],
	"2075": [
		17796,
		32778,
		44866,
		52950
	],
	"2102": [
		17796,
		32778,
		44866,
		52950
	],
	"2356": [
		17796
	],
	"2691": [
		81307
	],
	"2814": [
		52950
	],
	"3036": [
		52950
	],
	"3415": [
		17796,
		32778,
		37376,
		44866,
		47584,
		52950
	],
	"3680": [
		17796,
		52950
	],
	"3777": [
		52950,
		53140,
		64788
	],
	"3804": [
		1014,
		1420,
		1474,
		18298,
		52950,
		53140,
		64788,
		74924
	],
	"3835": [
		17796,
		52950,
		95399
	],
	"4175": [
		1420,
		17796,
		18298,
		52950,
		53140,
		64788,
		74924
	],
	"4456": [
		17796,
		32778,
		44866
	],
	"4646": [
		1420,
		11288,
		17796,
		18298,
		32778,
		44866,
		52950,
		53140,
		64788,
		74924
	],
	"4950": [
		1420,
		5130,
		17796,
		29890,
		32778,
		44866,
		52950,
		53140,
		64788,
		74924
	],
	"5072": [
		17796,
		32778,
		44866,
		52950,
		81307
	],
	"5175": [
		1014,
		1420,
		1474,
		5130,
		11288,
		17796,
		18298,
		29890,
		30734,
		32778,
		44866,
		52950,
		53140,
		56428,
		64788,
		74924
	],
	"5541": [
		1014,
		1420,
		5130,
		17796,
		29890,
		32778,
		44866,
		52950,
		53140,
		64788,
		74924,
		76144
	],
	"5728": [
		1420,
		17796,
		18298,
		32124,
		32778,
		44866,
		50568,
		52950,
		53140,
		56428,
		64788,
		74924
	],
	"6045": [
		32778,
		44866,
		52950,
		64496
	],
	"6443": [
		32778,
		44866,
		52950
	],
	"6787": [
		17796,
		52950
	],
	"7024": [
		1014,
		1420,
		18298,
		52950,
		53140,
		64788,
		74924
	],
	"7049": [
		1420,
		11288,
		17796,
		30734,
		32778,
		44866,
		52950,
		53140,
		64788,
		74924
	],
	"7491": [
		17796,
		32778,
		44866,
		52950
	],
	"7580": [
		32778,
		44866,
		53358,
		57576
	],
	"7699": [
		17796,
		52950
	],
	"7912": [
		17796,
		32778,
		44866,
		52950
	],
	"7935": [
		44866
	],
	"7989": [
		44866,
		52950
	],
	"8055": [
		40992
	],
	"8223": [
		1420,
		5130,
		11288,
		18298,
		29890,
		30734,
		32778,
		44866,
		50568,
		52950,
		53140,
		64788,
		74924
	],
	"8615": [
		32778,
		44866,
		52950
	],
	"8824": [
		32778,
		44866
	],
	"8827": [
		1014,
		1420,
		18298,
		52950,
		53140,
		64788,
		74924
	],
	"9168": [
		17796
	],
	"9180": [
		44866,
		52950
	],
	"9227": [
		52950
	],
	"9322": [
		1474,
		11288,
		17796,
		18298,
		32778,
		44866,
		50568,
		52950,
		53140,
		64788,
		78764
	],
	"9539": [
		32778,
		44866,
		52950
	],
	"9552": [
		1420,
		17796,
		52950,
		53140,
		64788
	],
	"9721": [
		17796,
		32778,
		44866
	],
	"9771": [
		1014,
		1420,
		11288,
		17796,
		18298,
		29890,
		30734,
		32124,
		32778,
		44866,
		50568,
		52950,
		53140,
		56428,
		64788,
		74924
	],
	"9872": [
		17796,
		32778,
		44866
	],
	"9940": [
		17796,
		32778,
		44866,
		52950
	],
	"9975": [
		17796,
		32778,
		44866,
		52950
	],
	"9999": [
		64496
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}